<template>
    <section class="line">
        <ul class="timeline-with-icons mx-3">
            <li class="timeline-item mb-3 p-2" v-for="event in events" :key="event.id">
                <span class="timeline-icon">
                    <i class="text-primary fa-sm fa-fw" :class="event.icon"></i>
                </span>

                <h5 class="fw-bold">{{ event.title }}</h5>
                <p class="text-muted mb-2 fw-bold">{{ event.date }}</p>
                <p class="text-muted" v-html="event.message"></p>
            </li>
        </ul>
    </section>
</template>

<script>
    export default {
        name: 'TimeLineComponent',
        props: {
            events: {
                type: Array,
                required: true,
                validator(value) {
                    return value.every(evento => 
                        typeof evento.id === 'number' &&
                        typeof evento.icon === 'string' &&
                        typeof evento.date === 'string' &&
                        typeof evento.title === 'string' &&
                        typeof evento.message === 'string'
                    );
                }
            }
        }
    }
</script>

<style scoped>
    .line {
        max-height: 500px;
        overflow: scroll;
    }
    .timeline-with-icons {
        border-left: 1px solid hsl(0, 0%, 90%);
        position: relative;
        list-style: none;
    }
    .timeline-with-icons .timeline-item {
        position: relative;
        background-color: rgb(241, 241, 241);
        border-radius: .25rem;
    }
    .timeline-with-icons .timeline-item:after {
        position: absolute;
        display: block;
        top: 0;
    }
    .timeline-with-icons .timeline-icon {
        position: absolute;
        left: -55px;
        background-color: hsl(217, 88.2%, 90%);
        color: hsl(217, 88.8%, 35.1%);
        border-radius: 50%;
        height: 31px;
        width: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>